export default [{
  type: 'tab',
  active: '0',
  items: [{
    title: '属性',
    labelWidth: '100px',
    items: [{
      text: '组件名称',
      name: 'name',
    }, {
      text: 'type',
      name: 'type',
      type: 'hidden',
    }, {
      name: 'activeIndex',
      type: 'number',
      text: '默认激活项',
      defaultValue: 0,
      extra: '从零开始的标签项索引',
    }, {
      name: 'isSaveActiveIndexToLocal',
      text: '是否记录上次激活项',
      type: 'switch',
      defaultValue: false,
      labelWidth: '150px',
    }, {
      name: 'isPreloadTab',
      text: '是否预加载',
      type: 'switch',
      defaultValue: false,
      extra: '用于解决切换时的闪动问题。如果开启，未激活的标签页的子组件将提前渲染，会影响曝光上报等功能。如不确定该功能带来的副作用，请与开发同学联系',
    }, {
      type: 'component',
      id: 'devConfig',
    }, {
      type: 'component',
      id: 'rect',
    }],
  },
  {
    title: '高级',
    items: [{
      type: 'tab',
      active: '0',
      lazy: true,
      items: [{
        title: '属性',
        labelWidth: '100px',
        items: [{
          name: 'id',
          text: 'ID',
          type: 'display',
        }, {
          text: 'className',
          name: 'className',
        }, {
          type: 'fieldset',
          text: '上报',
          labelWidth: '100px',
          name: 'report',
          extensible: true,
          items: [{
            name: 'module',
            items: [{
              text: '_module',
              name: '_module',
            }],
          }],
        }],
      }, {
        type: 'component',
        id: 'script',
      }],
    }],
  }],
}];
